<ng-template #templateRef>
    <form #editorForm="ngForm" name="editContact" (ngSubmit)="save()" id="crmContactEditor">
        <h2 mat-dialog-title>
            {{Copy && Copy.Id ? 'Edit' : 'New'}} contact
            <mat-icon *ngIf="Copy.ExternalId" class="text-right" matTooltip="Linked with SAP S4">insert_link</mat-icon>
        </h2>
        <mat-dialog-content *ngIf="Copy">
            <div class="row">
                <div *ngIf="!hideRelation" class="col-md-6">
                    <app-relation-selector name="Relation" [(ngModel)]="Copy.Relation" required></app-relation-selector>
                </div>
                <div [class.col-md-6]="!hideRelation" [class.col-12]="hideRelation">
                  <app-dropdown-option disabled discriminator="Type" model="Contact" name="Type" placeholder="Type"
                                       [(ngModel)]="Copy.Type"></app-dropdown-option>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                  <mat-form-field>
                    <mat-label>Full name</mat-label>
                    <input [(ngModel)]="Copy.Fullname" disabled matInput name="Fullname">
                  </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                      <mat-label>Job title</mat-label>
                      <input [(ngModel)]="Copy.JobTitle" disabled matInput name="JobTitle">
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field>
                      <mat-label>Gender</mat-label>
                      <mat-select [(ngModel)]="Copy.Gender" disabled name="Gender">
                        <mat-option value="M">Male</mat-option>
                        <mat-option value="V">Female</mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                      <mat-label>Phone</mat-label>
                      <input [(ngModel)]="Copy.Phone" disabled matInput name="Phone">
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field>
                      <mat-label>Mobile</mat-label>
                      <input [(ngModel)]="Copy.Mobile" disabled matInput name="Mobile">
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                      <mat-label>E-mail</mat-label>
                      <input disabled matInput name="Email" placeholder="Email" type="email"
                             [(ngModel)]="Copy.Email">
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                  <app-locale-selector [(ngModel)]="Copy.Locale" disabled name="Locale" placeholder="Language"></app-locale-selector>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <mat-form-field>
                      <mat-label>Remarks</mat-label>
                        <textarea disabled matInput name="Remarks"
                                  [(ngModel)]="Copy.Remarks"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-checkbox name="IsActive" [(ngModel)]="Copy.IsActive">Active</mat-checkbox>
                </div>
                <div class="col-md-6">
                  <mat-checkbox [(ngModel)]="Copy.IsDefault" disabled name="IsDefault"> Default</mat-checkbox>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button mat-button mat-raised-button [mat-dialog-close]="true">Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading || isLoadingEO"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>
